!function() {
  class t extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.productInfo = this.querySelector("[data-product-info]"), this.stickyProductLink = document.querySelector("[data-sticky-product-link]"), 
      this.productForm = this.querySelector("product-form"), this.productFormWrapper = this.querySelector("[data-product-form-wrapper]"), 
      this.productSubmitButtons = this.querySelectorAll("[data-submit]"), this.stickyAddToCart = document.querySelector("[data-sticky-add-to-cart]"), 
      this.stickyAddToCartMobile = document.querySelector("[data-sticky-add-to-cart-mobile]"), 
      this.linkGrid = document.querySelector("[data-link-grid]"), this.isProductFormPassed = !1, 
      this.isLinkGridVisible = !1, this.hasScrolledPastLinkGrid = !1, this.productInfo && (this.setProductInfoHeight(), 
      this.resizeObserver = new ResizeObserver(() => this.setProductInfoHeight()), this.resizeObserver.observe(this.productInfo)), 
      this.productInfo && this.stickyProductLink && (this.initIntersectionObserver(), 
      this.initSwipeGesture()), this.productSubmitButtons.length && (this.stickyAddToCart || this.stickyAddToCartMobile) && this.initProductFormObserver(), 
      this.linkGrid && (this.stickyAddToCart || this.stickyAddToCartMobile) && this.initLinkGridObserver(), 
      (this.stickyAddToCart || this.stickyAddToCartMobile) && this.updateStickyCartVisibility(), 
      this.addReviewsClickListener();
    }
    disconnectedCallback() {
      this.resizeObserver && this.resizeObserver.disconnect(), this.intersectionObserver && this.intersectionObserver.disconnect(), 
      this.productFormObserver && this.productFormObserver.disconnect(), this.linkGridObserver && this.linkGridObserver.disconnect(), 
      this.stickyProductLink && (this.stickyProductLink.removeEventListener("touchstart", this.handleTouchStart), 
      this.stickyProductLink.removeEventListener("touchend", this.handleTouchEnd));
    }
    setProductInfoHeight() {
      const t = this.productInfo.offsetHeight;
      this.style.setProperty("--spacing-product-info-height", `${t}px`);
    }
    updateStickyCartVisibility() {
      const t = this.isProductFormPassed && !this.hasScrolledPastLinkGrid && !this.isLinkGridVisible;
      this.stickyAddToCart && window.innerWidth >= 1024 && (this.stickyAddToCart.classList.toggle("opacity-0", !t), 
      this.stickyAddToCart.classList.toggle("pointer-events-none", !t)), this.stickyAddToCartMobile && window.innerWidth < 1024 && (this.stickyAddToCartMobile.classList.toggle("opacity-0", !t), 
      this.stickyAddToCartMobile.classList.toggle("pointer-events-none", !t));
    }
    initIntersectionObserver() {
      this.intersectionObserver = new IntersectionObserver(t => {
        t.forEach(t => {
          t.isIntersecting ? this.stickyProductLink.classList.add("opacity-0") : this.stickyProductLink.classList.remove("opacity-0");
        });
      }, {
        rootMargin: "0px 0px 0px 0px"
      }), this.intersectionObserver.observe(this.productInfo);
    }
    initProductFormObserver() {
      this.productFormObserver = new IntersectionObserver(t => {
        t.forEach(t => {
          const {isIntersecting: i, boundingClientRect: e} = t;
          this.isProductFormPassed = !i && e.y < 0, this.updateStickyCartVisibility();
        });
      }, {
        rootMargin: "0px"
      }), this.productSubmitButtons.forEach(t => {
        this.productFormObserver.observe(t);
      });
    }
    initLinkGridObserver() {
      this.linkGridObserver = new IntersectionObserver(t => {
        t.forEach(t => {
          const {isIntersecting: i, boundingClientRect: e} = t;
          this.isLinkGridVisible = i, !i && e.y < 0 ? this.hasScrolledPastLinkGrid = !0 : i && (this.hasScrolledPastLinkGrid = !1), 
          this.updateStickyCartVisibility();
        });
      }, {
        rootMargin: "0px"
      }), this.linkGridObserver.observe(this.linkGrid);
    }
    initSwipeGesture() {
      this.touchStartY = 0, this.handleTouchStart = this.handleTouchStart.bind(this), 
      this.handleTouchEnd = this.handleTouchEnd.bind(this), this.stickyProductLink.addEventListener("touchstart", this.handleTouchStart, {
        passive: !0
      }), this.stickyProductLink.addEventListener("touchend", this.handleTouchEnd);
    }
    handleTouchStart(t) {
      this.touchStartY = t.touches[0].clientY;
    }
    handleTouchEnd(t) {
      const i = t.changedTouches[0].clientY;
      this.touchStartY - i > 50 && (t.preventDefault(), this.productFormWrapper.scrollIntoView({
        behavior: "smooth"
      }));
    }
    addReviewsClickListener() {
      const t = document.querySelector('a[href="#Reviews"]');
      t && t.addEventListener("click", t => {
        t.preventDefault(), document.getElementById("Reviews")?.querySelector("details summary")?.click();
      });
    }
  }
  customElements.get("product-wrapper") || customElements.define("product-wrapper", t);
}();